import { GET_RECIPIENTS, GET_UPDATE_RECIPIENT_DATA } from 'store/constants'

export function getRecipients(values) {
    return {
        type: GET_RECIPIENTS,
        payload: values,
    }
}

export function updateRecipient(values) {
    return {
        type: GET_UPDATE_RECIPIENT_DATA,
        payload: values,
    }
}